<template lang="pug">
div.padding.p-t-0
    div.row
        div.col-md-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="user_id", slot-scope="props")
                        span(v-if="props.row.user !== null") {{ props.row.user.name }}
                        i.text-muted(v-else) N/A
</template>

<script>
const TableName = 'VUETABLE_audit_trail';

export default {
    data() {
        var that = this;

        return {
            tableName: TableName,
            columns: [
                'transaction_date',
                'transaction_type',
                'stock_name',
                'sku',
                'user_id',
                'outlet',
                'quantity_before',
                'transaction_quantity',
                'quantity_after',
            ],
            options: {
                useReportFilter: true,
                orderBy: {
                    column: 'transaction_date',
                    ascending: false,
                },
                templates: {
                    transaction_type(h, row) {
                        return require('./columns/transaction_type.jsx')(
                            h,
                            row,
                        );
                    },
                    transaction_date(h, row) {
                        return require('./columns/transaction_date.jsx')(
                            h,
                            row,
                        );
                    },
                    user_id(h, row) {
                        return require('./columns/user.jsx')(h, row);
                    },
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('audit_trail.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/audit_trail/audit-trail-list.vue